const isIe = () => {
  const { userAgent } = window.navigator
  return /(MSIE|Trident)/i.test(userAgent)
}

export default isIe
